module.exports = __webpack_public_path__ + "img/icon23.4f23c093.png";